module.exports = __webpack_public_path__ + "hu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/hu.svg
// module id = 857
// module chunks = 0